import React from "react";
import { TertiaryButton, Form } from "components";
import "./styles.scss";
export const ImagePicker = (props) => {
  const [query, setQuery] = React.useState("");
  const [images, setImages] = React.useState([]);
  const searchPhotos = async (e) => {
    e.preventDefault();
    const results = await fetch(
      `https://api.unsplash.com/search/photos?page=1&query=${query}&client_id=${process.env.REACT_APP_UNSPLASH_ACCESS_KEY}`
    );
    const data = await results.json();
    setImages(data.results);
  };

  const renderImages = () => {
    return images.map((image) => (
      <div className="image__picker__item" key={image.id}>
        <img src={image.urls.regular} alt={image.alt_description} />
      </div>
    ));
  };
  return (
    <>
      <Form onSubmit={searchPhotos}>
        <label htmlFor="image">Buscar imagen</label>
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          type="text"
          name="image"
          placeholder="Buscar imagen"
        />
        <TertiaryButton type="submit" modifiers={["small", "autoWidth"]}>
          Buscar
        </TertiaryButton>
      </Form>
      <div className="image__picker">{renderImages()}</div>
    </>
  );
};
